function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st-dnv{fill:#FFFFFF;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 78.7,
  y: 79,
  className: "st-dnv",
  width: 612.3,
  height: 73.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 78.7,
  y: 176.4,
  className: "st-dnv",
  width: 612.3,
  height: 12.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 78.7,
  y: 200.8,
  className: "st-dnv",
  width: 612.3,
  height: 24.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st-dnv",
  d: "M449,265.9c-6-2.7-13.2-4-21.5-4h-29.5h-7.2H385v78.6h5.9h7.2h29.5c8.3,0,15.5-1.3,21.5-4 c6-2.7,10.6-6.7,13.8-12.2c3.2-5.4,4.8-12.2,4.8-20.4v-5.5c0-8.2-1.6-15-4.8-20.4C459.6,272.7,455,268.6,449,265.9z M454.8,303.5 c0,8.5-2.3,14.9-6.8,19c-4.5,4.1-11.3,6.2-20.3,6.2h-29.6v-54.9h29.6c9,0,15.8,2,20.3,6c4.5,4,6.8,10.4,6.8,19.1V303.5z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st-dnv",
  points: "566.1,323.3 505.3,261.9 498.1,261.9 492.5,261.9 492.5,340.5 505.3,340.5 505.3,279.1 566.1,340.5  579,340.5 579,261.9 566.1,261.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st-dnv",
  points: "677,261.9 646.9,323.3 616.8,261.9 602.1,261.9 641.5,340.5 651.6,340.5 691,261.9  "
}));

const SvgDnvglLogo = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 769 418.5",
    style: {
      enableBackground: "new 0 0 769 418.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDnvglLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dnvgl-logo.b446ae21.svg";
export { ForwardRef as ReactComponent };